import $ from 'jquery';
import 'slick-carousel';

const Carousel = (el) => {
    $(el).slick({
        'autoplay': true,
        'dots': true,
        'arrows': false,
        'fade': true,
        'speed': 500,
    });
}

export default Carousel;
